import { useEffect, useState } from "react"
import { dateToSlice, getDeviceTimeZone, getImage, getMomentDate, NTformatDate } from "../../utils"
import moment from "moment"
import { useDispatch, useSelector } from "react-redux"
import { activateRange, disableRange, getDayAvailability } from "../../store/appointment/appointmentActions"
import { CancelRangeEvent } from "../../components/course/cancelRange"
import { RescheduleRangeEvent } from "../../components/course/rescheduleRange"
import { FaAngleDown, FaAngleUp } from "react-icons/fa6"

const RangeEventSelected = ({ currentEvent, events = [], refreshCalendar, setIsOpen, isMobile = false, isMobileToggled, setIsMobileToggled }) => {
    const [isCancel, setIsCancel] = useState(false);
    const [isReschedule, setIsReschedule] = useState(false);
    const [isEnabling, setIsEnabling] = useState(false);
    const [isDisabling, setIsDisabling] = useState(false);
    const [availableOptions, setAvailableOptions] = useState([]);
    const { user } = useSelector((state) => state.auth)
    const { currentProfile } = useSelector((state) => state.profile)
    const dispatch = useDispatch();

    useEffect(() => {
        setIsDisabling(false)
        setIsEnabling(false)
        setIsReschedule(false)
        setIsCancel(false)
    }, [currentEvent.startStr, currentEvent.endStr])

    const getDayAvailabilityAction = (day) => {
        setAvailableOptions([]);
        dispatch(getDayAvailability({
            profile: currentProfile._id,
            day: NTformatDate(day, user.timezone)
        }))
            .unwrap()
            .then(v => {
                const slices = v.map((slice => {
                    return {
                        value: getMomentDate(slice.date),
                        label: dateToSlice(slice.date)
                    };
                }))

                setAvailableOptions(slices)
            })
    }

    const handleCancelCourse = () => {
        setIsCancel(true)
    }

    const Appointment = ({ event }) => {
        return <div className='flex items-center gap-2 rounded-xl border border-slate-200 bg-white p-2.5'>
            <img className='h-10 w-10 rounded-full object-cover' src={getImage(event.avatar, "AVATAR")} />
            <div className='min-w-0'>
                <h4 className='truncate text-sm capitalize text-nt-blue'>{event.title}</h4>
                <span className='text-xs text-nt-grey'>{moment(event.date).parseZone().format("YYYY-MM-DD HH:mm").toString()}</span>
            </div>
        </div>
    }

    const handleActivateRange = () => {
        const userTz = getDeviceTimeZone()
        dispatch(activateRange({
            start: moment(currentEvent.startStr).parseZone().format("YYYY-MM-DDTHH:mm:ss") + userTz,
            end: moment(currentEvent.endStr).parseZone().format("YYYY-MM-DDTHH:mm:ss") + userTz,
        }))
            .unwrap()
            .then(() => {
                refreshCalendar()
                setIsEnabling(false)
                setIsOpen(false)
            })
    }

    const handleDisableRange = () => {
        const userTz = getDeviceTimeZone()
        dispatch(disableRange({
            start: moment(currentEvent.startStr).parseZone().format("YYYY-MM-DDTHH:mm:ss") + userTz,
            end: moment(currentEvent.endStr).parseZone().format("YYYY-MM-DDTHH:mm:ss") + userTz,
        }))
            .unwrap()
            .then(() => {
                setIsDisabling(false);
                setIsOpen(false)
                refreshCalendar()
            })
    }

    return <div className="space-y-4">
        <div className="rounded-xl border border-slate-200 bg-slate-50 p-3.5">
            <div className="mb-2 flex items-center justify-between">
                <h4 className='text-sm font-semibold text-nt-blue'>Selected range</h4>
                {isMobile ? <button className='ms-2 flex h-8 w-8 items-center justify-center rounded-full border border-nt-blue text-nt-blue' onClick={() => setIsMobileToggled((x) => !x)}>
                    {isMobileToggled ? <FaAngleDown /> : <FaAngleUp />}
                </button> : null}
            </div>
            <div className="space-y-1">
                <p className='text-xs uppercase tracking-wide text-slate-500'>From</p>
                <p className='text-sm font-medium text-nt-blue'>{moment(currentEvent.startStr).parseZone().format("YYYY-MM-DD HH:mm").toString()}</p>
                <p className='pt-1 text-xs uppercase tracking-wide text-slate-500'>To</p>
                <p className='text-sm font-medium text-nt-blue'>{moment(currentEvent.endStr).parseZone().format("YYYY-MM-DD HH:mm").toString()}</p>
            </div>
        </div>

        {(isDisabling && !isReschedule && events.length > 0) ? (
            <div className="space-y-2 rounded-xl border border-amber-200 bg-amber-50/70 p-3">
                <h5 className="text-sm font-semibold text-amber-900">Affected courses ({events.length})</h5>
                <div className="max-h-56 space-y-2 overflow-y-auto pe-1">
                    {events.map((ev, i) => {
                        return <div key={ev._id || i}>
                            <Appointment event={ev} />
                        </div>
                    })}
                </div>
            </div>
        ) : null}

        {(!isDisabling && !isReschedule && !isEnabling && !isCancel) && <div className="space-y-2.5">
            <button className="w-full rounded-xl bg-nt-blue px-3 py-3 text-sm font-medium text-white transition hover:opacity-95" onClick={() => { setIsEnabling(true) }}>
                Activate selected range
            </button>
            <button className="w-full rounded-xl bg-nt-red px-3 py-3 text-sm font-medium text-white transition hover:opacity-95" onClick={() => { setIsDisabling(true) }}>
                Deactivate selected range
            </button>
            <button className="w-full rounded-xl bg-slate-200 px-3 py-3 text-sm font-medium text-slate-700 transition hover:bg-slate-300" onClick={() => { setIsOpen(false) }}>
                Close
            </button>
        </div>}

        {(isDisabling && !isReschedule && events.length > 0 && !isCancel) && <div className="space-y-2.5 rounded-xl border border-amber-200 bg-amber-50 p-3">
            <p className="text-xs text-amber-800">
                This range includes booked courses. Choose how you want to handle them before deactivation.
            </p>
            <button className="w-full rounded-xl bg-nt-blue px-3 py-3 text-sm font-medium text-white transition hover:opacity-95" onClick={() => { setIsReschedule(true); getDayAvailabilityAction(moment().add(1, "day").toDate()) }}>
                Reschedule courses
            </button>
            <button className="w-full rounded-xl bg-nt-red px-3 py-3 text-sm font-medium text-white transition hover:opacity-95" onClick={() => handleCancelCourse()}>
                Cancel courses
            </button>
            <button className="w-full rounded-xl bg-slate-200 px-3 py-3 text-sm font-medium text-slate-700 transition hover:bg-slate-300" onClick={() => setIsDisabling(false)}>
                Back
            </button>
        </div>}

        {(isEnabling) && <div className="space-y-3 rounded-xl border border-emerald-200 bg-emerald-50 p-3">
            <h4 className="text-sm font-semibold text-emerald-900">Activate this range?</h4>
            <p className="text-xs text-emerald-800">Users will be able to book sessions in this time window.</p>
            <button className="w-full rounded-xl bg-nt-blue px-3 py-3 text-sm font-medium text-white transition hover:opacity-95" onClick={() => handleActivateRange()}>
                Confirm activation
            </button>
            <button className="w-full rounded-xl bg-slate-200 px-3 py-3 text-sm font-medium text-slate-700 transition hover:bg-slate-300" onClick={() => setIsEnabling(false)}>
                Back
            </button>
        </div>}

        {(isDisabling && events.length === 0) && <div className="space-y-3 rounded-xl border border-rose-200 bg-rose-50 p-3">
            <h4 className="text-sm font-semibold text-rose-900">Deactivate this range?</h4>
            <p className="text-xs text-rose-800">No bookings found in this range. This will block new bookings for this period.</p>
            <button className="w-full rounded-xl bg-nt-red px-3 py-3 text-sm font-medium text-white transition hover:opacity-95" onClick={() => handleDisableRange()}>
                Confirm deactivation
            </button>
            <button className="w-full rounded-xl bg-slate-200 px-3 py-3 text-sm font-medium text-slate-700 transition hover:bg-slate-300" onClick={() => setIsDisabling(false)}>
                Back
            </button>
        </div>}

        {isCancel && <CancelRangeEvent setIsOpen={() => setIsOpen()} setIsCancel={() => setIsCancel()} currentEvent={currentEvent} events={events} refreshParent={() => refreshCalendar()}
            setIsDisabling={(v) => { setIsDisabling(v); setIsOpen(false) }} />}

        {isReschedule && <RescheduleRangeEvent setIsOpen={(v) => setIsOpen(v)} setIsReschedule={(v) => setIsReschedule(v)} setIsDisabling={(v) => setIsDisabling(v)} key={events} currentEvent={currentEvent} events={events} refreshParent={() => refreshCalendar()} />}
    </div>
}

export { RangeEventSelected }